import { createStyles } from "@material-ui/core";

export type PercentagesClassKey = "pageTitle";

export const PercentagesStyleRules = createStyles({
  pageTitle: {
    marginTop: "40px",
  },
});
